import {
  Form,
  Input,
  Button,
  Card,
  Spin,
  Select,
  Modal,
  DatePicker,
  AutoComplete,
  Icon,
} from "antd";
import React, { Component } from "react";
import { showSuccessToast } from "../general/ToastHelper";
import withSharedStateConsumer from "../../contexts/shared-state/withSharedStateConsumer";
import { withRouter } from "react-router-dom";
import { handleError } from "../../utils/ErrorHandlers";
import Page from "../general/Page";
import "./createTickets.css";
import "./tickets.css";
import { Constants } from "../../data/constants";
import { TicketCategoryService } from "../../services/ticketCategory/TicketCategoryService";
import { CustomerService } from "../../services/customer/CustomerService";
import CreateCustomerForm from "../customers/createCustomerForm";
import { UserService } from "../../services/user/UserService";
import TextArea from "antd/lib/input/TextArea";
import { TicketService } from "../../services/Ticket/TicketService";
import { Translation } from "react-i18next";
import i18next from "i18next";
import moment from "moment";
import ar from "antd/es/date-picker/locale/ar_EG";
import en from "antd/es/date-picker/locale/en_US";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);

class CreateTicketForm extends Component {
  constructor(props) {
    super(props);

    this.props.context.setCurrentComponent("createTicket");
    this.constants = new Constants();
    this.ticketCategoryService = new TicketCategoryService();
    this.customerService = new CustomerService();
    this.userService = new UserService();
    this.ticketService = new TicketService();
    this.state = {
      ticket: {},
      isFetching: false,
      addloading: false,
      submitLoading: false,
      loading: false,
      formLayout: "inline",
      editMode: false,
      userType: this.props.context.user.userType,
      allTicketCategory: [],
      allUsers: [],
      adminUsers: [],
      allCustomers: [],
      selectedDate: "",
      displayedCategory: "",
      displayedCustomer: "",
      addCustomerFromTicket: false,
      comment: "",
      openModel: false,
      lang:
        this.props.context.curr_lang === "ar" &&
        this.props.context.curr_dir === "rtl"
          ? "ar"
          : "en",
    };
  }

  async componentDidMount() {
    this.setState({ isFetching: true });
    try {
      let users = [];
      let adminUsers = [];

      let [categories, customers] = await Promise.all([
        this.getAllTicketCategory(),
        this.getAllCustomers(),
      ]);

      if (this.state.userType === "ADMIN") {
        users = await this.getAllUsers();
      } else {
        adminUsers = await this.filterUsersByType();
        adminUsers.ivrList.push({
          userId: this.props.context.user.userId,
          userFullname: this.props.context.user.userFullname,
        });
      }
      let filterCategory = categories.ivrList.filter((val) => {
        return val.status === "ACT";
      });

      this.setState({
        allTicketCategory: filterCategory,
        allUsers: users.ivrList,
        allCustomers: customers.ivrList,
        displayedCategory: filterCategory.length
          ? filterCategory[0].name
          : null,
        displayedCustomer: customers.ivrList.length
          ? customers.ivrList.at(-1).customerId
          : null,

        adminUsers: adminUsers.ivrList,
        isFetching: false,
        openModel: false,
      });
    } catch (e) {
      this.setState({ isFetching: false });
      handleError(e);
    }
  }
  async getAllTicketCategory() {
    try {
      let data = await this.ticketCategoryService.getAllTicketCategoryService(
        this.props.context.session_id
      );
      return data;
    } catch (e) {
      handleError(e);
    }
  }
  async getAllUsers() {
    try {
      let data = await this.userService.getAllUsersByAccountIdService(
        this.props.context.session_id
      );
      return data;
    } catch (e) {
      handleError(e);
    }
  }
  async getAllCustomers() {
    try {
      let data = await this.customerService.getAllCustomersForTickets(
        this.props.context.session_id
      );
      return data;
    } catch (e) {
      handleError(e);
    }
  }

  async filterUsersByType() {
    try {
      let data = await this.userService.getUserByTypeService(
        this.props.context.session_id,
        "ADMIN"
      );
      return data;
    } catch (e) {
      handleError(e);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.key !== this.props.location.key) {
      this.componentDidMount();
    }
  }

  handleConfirm = (e) => {
    e.preventDefault();
    let history = this.props.history;
    this.props.form.validateFields(async (err, values) => {
      try {
        if (!err) {
          let selectedCustomer = this.state.allCustomers.filter((element) => {
            return element.customerId == values.customer;
          });
          let selectedAssignTo =
            this.state.userType === "ADMIN"
              ? this.state.allUsers.filter((element) => {
                  return element.userId == values.assignedTo;
                })
              : this.state.adminUsers.filter((element) => {
                  return element.userId == values.assignedTo;
                });
          if (!selectedCustomer.length) {
            handleError({
              message:
                i18next.t("This Customer (") +
                values.customer +
                i18next.t(") doesn't exist"),
            });
            return;
          }
          if (!selectedAssignTo.length) {
            handleError({
              message:
                i18next.t("This user (") +
                values.assignedTo +
                i18next.t(") doesn't exist"),
            });
            return;
          }

          this.setState({ loading: true });
          values["dueDate"] = this.state.selectedDate
            ? this.state.selectedDate
            : moment().format("yyyy-MM-DD");
          let data = await this.ticketService.createTicket(
            this.props.context.session_id,
            values
          );
          showSuccessToast(i18next.t(data.statusMsg));
          this.setState({ loading: false });
          this.props.form.resetFields();
          history.push("/home/tickets/");
        }
      } catch (e) {
        this.setState({ loading: false, visible: false });
        handleError(e);
      }
    });
  };

  getTextAreaInput(e) {
    this.setState({ comment: e.target.value });
  }

  onDateChange = (data, dateString) => {
    this.setState({ selectedDate: dateString });
  };

  showCustomerModal = () => {
    this.setState({ openModel: true, addCustomerFromTicket: true });
  };
  handleOk = () => {
    this.setState({ openModel: false });
  };

  handleCancel = () => {
    this.setState({ openModel: false, addCustomerFromTicket: false });
  };

  disabledDate = (current) => {
    // Can not select days after today
    return current <= dayjs().startOf("day");
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
    };

    let {
      allTicketCategory,
      allUsers,
      allCustomers,
      isFetching,
      userType,
      adminUsers,
      displayedCustomer,
    } = this.state;
    const { Option } = Select;

    const ticketCategoryOptions = allTicketCategory.length
      ? allTicketCategory.map((opt) => (
          <Option key={opt.name} value={opt.code}>
            {opt.name}
          </Option>
        ))
      : null;
    const customersOptions = allCustomers.map((opt) => (
      <Option key={opt.customerFullname} value={opt.customerId}>
        {opt.customerFullname}
      </Option>
    ));

    const UsersOptions = allUsers
      ? allUsers.map((opt) => (
          <Option key={opt.userFullname} value={opt.userId}>
            {opt.userFullname}
          </Option>
        ))
      : "";
    const agentUserOptions = adminUsers
      ? adminUsers.map((opt) => (
          <Option key={opt.userFullname} value={opt.userId}>
            {opt.userFullname}
          </Option>
        ))
      : "";

    return (
      <Translation>
        {(t) => (
          <Page title={t("Create Ticket ")} hasBackArrow={true}>
            {isFetching ? (
              <Spin></Spin>
            ) : (
              <div>
                <Card
                  style={{
                    marginTop: "10px",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                  }}
                  bordered={false}
                >
                  <Form className="form-style" {...formItemLayout}>
                    <Form.Item
                      wrapperCol={{
                        xs: { span: 24, offset: 3 },
                        sm: { span: 16, offset: 8 },
                      }}
                    >
                      <Button
                        className="button-submit"
                        type="primary"
                        onClick={this.showCustomerModal}
                        size={"small"}
                        loading={this.state.addloading}
                      >
                        {t("Add New Customer")}
                      </Button>
                    </Form.Item>
                    <Form.Item label={t("Customer")} {...formItemLayout}>
                      {getFieldDecorator("customer", {
                        initialValue: displayedCustomer,

                        rules: [
                          {
                            required: true,
                            message: t("Please select Customer to be assigned"),
                          },
                        ],
                      })(
                        <AutoComplete
                          className="certain-category-search"
                          dropdownClassName="certain-category-search-dropdown"
                          dropdownMatchSelectWidth={false}
                          //dropdownStyle={{ width: 300 }}
                          size="large"
                          style={{ width: "100%" }}
                          placeholder={t("Please enter customer name")}
                          dataSource={customersOptions}
                          onSelect={this.onSelect}
                          filterOption={(inputValue, option) =>
                            option.props.children
                              .toUpperCase()
                              .indexOf(inputValue.toUpperCase()) !== -1
                          }
                        >
                          <Input
                            suffix={
                              <Icon
                                type="search"
                                className="certain-category-icon"
                              />
                            }
                          />
                        </AutoComplete>
                      )}
                    </Form.Item>

                    <Form.Item label={t("Ticket Category")} {...formItemLayout}>
                      {getFieldDecorator("categoryCode", {
                        initialValue: this.state.displayedCategory,
                        /* ticketCategoryOptions[0].props.value
                      ? ticketCategoryOptions[0].props.value
                      : "", */
                        rules: [
                          {
                            required: true,
                            message: t("Please select Ticket Category "),
                          },
                        ],
                      })(
                        <Select placeholder={t("Select Ticket Category")}>
                          {ticketCategoryOptions}
                        </Select>
                      )}
                    </Form.Item>

                    <Form.Item label={t("Priority")} {...formItemLayout}>
                      {getFieldDecorator("priority", {
                        initialValue: "Normal",

                        rules: [
                          {
                            required: true,
                            message: t("Please select Priority"),
                          },
                        ],
                      })(
                        <Select placeholder={t("Select ")}>
                          <Option value={"Critical"}>{t("Critical")}</Option>
                          <Option value={"High"}>{t("High")}</Option>
                          <Option value={"Normal"}>{t("Normal")}</Option>
                          <Option value={"Low"}>{t("Low")}</Option>
                        </Select>
                      )}
                    </Form.Item>
                    <Form.Item label={t("Subject")} {...formItemLayout}>
                      {getFieldDecorator("subject", {
                        initialValue: "",

                        rules: [
                          {
                            required: true,
                            message: t("Please enter Ticket Subject"),
                          },
                        ],
                      })(
                        <Input placeholder={t("Enter Ticket Subject")}></Input>
                      )}
                    </Form.Item>
                    {/* {userType === "ADMIN" ? ( */}
                    <Form.Item label={t("Assign To")} {...formItemLayout}>
                      {getFieldDecorator("assignedTo", {
                        initialValue: "",

                        rules: [
                          {
                            required: true,
                            message: t("Please select user to be assigned"),
                          },
                        ],
                      })(
                        <AutoComplete
                          className="certain-category-search"
                          dropdownClassName="certain-category-search-dropdown"
                          dropdownMatchSelectWidth={false}
                          dropdownStyle={{ width: 300 }}
                          size="large"
                          style={{ width: "100%" }}
                          placeholder={t("Select User to assign  ")}
                          dataSource={
                            userType === "ADMIN"
                              ? UsersOptions
                              : agentUserOptions
                          }
                          onSelect={this.onSelect}
                          filterOption={(inputValue, option) =>
                            option.props.children
                              .toUpperCase()
                              .indexOf(inputValue.toUpperCase()) !== -1
                          }
                        >
                          <Input
                            suffix={
                              <Icon
                                type="search"
                                className="certain-category-icon"
                              />
                            }
                          />
                        </AutoComplete>
                      )}
                    </Form.Item>
                    {/* ) : (
                  <Form.Item label="Assign To" {...formItemLayout}>
                    {getFieldDecorator("assignedTo", {
                      initialValue: this.props.context.user.userFullname,
                    })(<Input disabled></Input>)}
                    agentUserOptions
                  </Form.Item>
                )} */}
                    <Form.Item label={t("Status")} {...formItemLayout}>
                      {getFieldDecorator("status", {
                        initialValue: "Open",

                        rules: [
                          {
                            required: true,
                            message: t("Please select Ticket Status"),
                          },
                        ],
                      })(
                        <Select placeholder={t("Select Ticket Status ")}>
                          <Option value={"Open"}>{t("Open")}</Option>
                          <Option value={"Resolved"}>{t("Resolved")}</Option>
                          <Option value={"Closed"}>{t("Closed")}</Option>
                          <Option value={"Invalid"}>{t("Invalid")}</Option>
                        </Select>
                      )}
                    </Form.Item>
                    <Form.Item label={t("Due Date")} {...formItemLayout}>
                      <DatePicker
                        disabledDate={this.disabledDate}
                        defaultValue={moment()}
                        onChange={this.onDateChange}
                        locale={this.state.lang === "ar" ? ar : en}
                        format={"yyyy-MM-DD"}
                        allowClear={false}
                      />
                    </Form.Item>
                    <Form.Item label={t("Comments")} {...formItemLayout}>
                      {getFieldDecorator("comment", {
                        initialValue: "",

                        rules: [
                          {
                            required: false,
                          },
                        ],
                      })(
                        <TextArea
                          rows={4}
                          maxLength={250}
                          onChange={(value) => this.getTextAreaInput(value)}
                          placeholder={t("Please Enter Your Comment")}
                        ></TextArea>
                      )}
                    </Form.Item>
                    <Form.Item
                      wrapperCol={{
                        xs: { span: 24, offset: 0 },
                        sm: { span: 16, offset: 8 },
                      }}
                    >
                      <Button
                        className="button-submit"
                        type="primary"
                        onClick={this.handleConfirm}
                        size={"small"}
                        loading={this.state.loading}
                      >
                        {t("Submit")}
                      </Button>
                    </Form.Item>
                  </Form>
                </Card>
                <Modal
                  className="createCustomerModal"
                  visible={this.state.openModel}
                  // onOk={this.handleOk}
                  onCancel={this.handleCancel}
                  style={{
                    padding: "0px !important",
                    border: "none !important",
                  }}
                  footer={[
                    <Button
                      key="submit"
                      type="primary"
                      loading={this.state.submitLoading}
                      onClick={this.addCustomer}
                      style={{ display: "none", padding: "0", border: "0" }}
                    >
                      {t("Add")}
                    </Button>,
                  ]}
                >
                  <CreateCustomerForm
                    addCustomerFromTicket={this.state.addCustomerFromTicket}
                  ></CreateCustomerForm>
                </Modal>
              </div>
            )}
          </Page>
        )}
      </Translation>
    );
  }
}
export default Form.create()(
  withSharedStateConsumer(withRouter(CreateTicketForm))
);
